import { Box, Typography } from "@mui/material";
import Api from "api";
import octa from "assets/images/calm.svg";
import CheckboxStyledWithLabel from "components/CheckboxStyledWithLabel";
import CustomButton from "components/customButton";
import { LoaderBackdrop } from "components/Loader";
import Panel from "components/missions/Panel";
import useUser from "hooks/useUser";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserActionType } from "reducers/userReducer";

function Grade()
{
	const navigate = useNavigate();
	const [ selected, setSelected ] = useState(0);
	const [ checked, setChecked ] = useState(false);
	const [ isError, setIsError ] = useState(false);
	const [ isLoading, setIsloading ] = useState(false);
	const userContext = useUser();
	// eslint-disable-next-line func-style
	const submit = () =>
	{
		if (selected === 0)
		{
			setIsError(true);
		}
		else
		{
			setIsloading(true);
			Api.users
				.updateUser({
					feedback: {
						rating: selected,
						confidence: checked
					}
				})
				.then(() =>
				{
					userContext.dispatch(
						{
							type: UserActionType.UPDATE_STATE,
							payload: {
								user: {
									feedback: {
										rating: selected,
										confidence: checked
									}
								}
							}
						}
					);
					setTimeout(() => navigate("/dashboard"), 0);
				})
				.catch((error) => console.error(error))
				.finally(() => setIsloading(false));
		}
	};

	return (
		<Box sx={{
			height: "100vh",
			background: "rgba(78, 181, 56, .06)",
			backdropFilter: "blur(40px)",
			width: "100%",
			display: "flex",
			flexDirection: "column"
			// justifyContent: "center"
		}}>
			<LoaderBackdrop isLoading={isLoading}>
				<Panel sx={{
					width: { xs: "680px !important", lg: "980px !important" },
					margin: "0 auto",
					padding: "100px 32px 80px 32px",
					display: "grid",
					gridTemplateRows: "auto 1fr",
					gap: "24px",
					background: "linear-gradient(103.55deg, rgba(207, 225, 255, 0.55) 9.99%, rgba(223, 223, 223, 0.13) 91.61%) !important",
					boxShadow: "none !important",
					mt: "150px",
					position: "relative"
				}}>
					<Box
						component="img"
						src={octa}
						sx={{
							display: { xs: "none", md: "block" },
							width: { xs: "140px", lg: "186px" },
							transform: "rotate(-5.6deg)",
							position: "absolute",
							top: { xs: "-52px", lg: "-73px" },
							right: { xs: "-93px", lg: "-125px" }
						}} />
					<Box sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center"
					}}>
						<Box sx={{
							color: "#fff",
							font: { xl: "700 40px/51px Lora-Bold", lg: "700 32px/40px Lora-Bold", xs: "700 24px/30px Lora-Bold" },
							textAlign: "center"
						}}>
							How likely are you to recommend<br /> My Life Quest to a friend?
						</Box>
						<Box sx={{ display: "flex", gap: "16px", flexWrap: "wrap", justifyContent: "center", mt: "94px" }}>
							{[ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ].map((item) => (
								<Box
									key={item}
									onClick={() => { setSelected(item); setIsError(false); }}
									sx={{
										cursor: "pointer",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										color: "#215C75",
										font: "700 22px/22px Lora-Bold",
										background: selected === item ? "#fff" : "rgba(255, 255, 255, 0.5)",
										borderRadius: "7.17px",
										height: { xs: "45px", lg: "71.73px" },
										width: { xs: "45px", lg: "71.73px" },
										boxShadow: selected === item ? "0 0 0 3px #215C75 inset" : "none",
										transition: "all 0.2s"
									}}>
									{item}
								</Box>
							))}
						</Box>
						<Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
							<Typography sx={{ color: "#fff", fontWeight: 300, fontFamily: "Open Sans", ml: "25px", mt: 1 }}>Not at all</Typography>
							<Typography sx={{ textAlign: "right", color: "#fff", fontWeight: 300, fontFamily: "Open Sans", mr: "25px", mt: 1 }}>Absolutely,<br /> they need this</Typography>
						</Box>
						{isError ? <Typography sx={{ color: "red" }}>Please rate</Typography> : null}
						<CheckboxStyledWithLabel
							label={
								<Typography sx={{
									color: "#FFFFFF",
									fontSize: { xs: "16px", lg: "22px" },
									fontWeight: 300,
									fontFamily: "Open Sans",
									mt: { xs: "0", lg: "-6px" }
								}}>
									✨<span style={{ fontWeight: 500 }}>Yes</span>, I’d love to help improve My Life Quest - happy to chat!
								</Typography>
							}
							checkboxProps={{
								checked: checked,
								onChange: () => setChecked(!checked)
							}}
							size="30px"
							sx={{ mt: 8 }}
						/>
					</Box>
				</Panel>
				<Box sx={{ display: "flex", justifyContent: "center", mt: "64px" }}>
					<CustomButton.Contained
						size="large"
						sx={{ background: "#fff", color: "primary.main" }}
						onClick={submit}
					>
						Finish
					</CustomButton.Contained>
				</Box>
			</LoaderBackdrop>
		</Box>
	);
}

export default Grade;
